import { BaseMargin, Category, Manufacturer, Price, Product } from '@/services/api/contracts/catalog/types';
import { Region } from '@/services/api/contracts/region';
import { BasicBetterBest } from '@/services/catalogue/useBasicBetterBest';
import { IncomingProduct } from '@/services/csv/helpers/parsers';

export const toProduct =
  (
    categories: Category[],
    categoryMap: Record<string, string>,
    manufacturers: Manufacturer[],
    manufacturerMap: Record<string, string>,
    regions: Region[],
    regionMap: Record<string, string>
  ) =>
  (
    product: IncomingProduct
  ): Omit<Product, 'id' | 'price' | 'code'> & { catalogPrice: Price; baseMargin: BaseMargin } => {
    const manufacturerId = manufacturerMap[product.Manufacturer];
    const manufacturer = manufacturers.find(m => m.id === manufacturerId);
    const categoryId = categoryMap[product.Category];
    const category = categories.find(c => c.id === categoryId);
    const regionId = regionMap[product.Region];
    const region = regions.find(c => c.id === regionId);

    if (!manufacturer) throw Error('No manufacturer');
    if (!category) throw Error('No category');
    if (!region) throw Error('No region');

    const bbb = product.BasicBetterBest
      ? (product.BasicBetterBest as unknown as BasicBetterBest)
      : BasicBetterBest.UNSET;

    return {
      name: product.Name,
      productId: product.ManufacturerSKU,
      manufacturer,
      category,
      description: {
        value: [{ type: 'p', children: [{ text: product.Description ?? '' }] }]
      },
      propertyBag: {
        properties: product.Specs.filter(spec => spec.value).map(spec => ({
          iconId: spec.type,
          text: spec.value
        })),
        basicBetterBest: bbb
      },
      catalogPrice: {
        price: product.Price,
        effectiveDate: {
          value: new Date()
        }
      },
      baseMargin: {
        modifier: product.Margin,
        effectiveDate: {
          value: new Date()
        }
      },
      region
    };
  };
